import { requests } from './baseServices'

export const LoginService = {
    login: (item) => requests.get(`api/auth/login`, item),
    changeSession: (userId) => requests.get(`api/auth/change-session`, { userId: userId }),
    logout: () => requests.delete(`api/auth/logout`),
    validateCode: (code, token) => requests.get(`api/auth/validate-code`, { token: token, code: code }),
};